
export async function action(callback) {
    try {
        const response = await callback();
        return [response, null];
    } catch (error) {
        return [null, error];
    }
}